// Zoomed overlay: pan with mouse or touch (original theme was mouse-only).

function prepareOverlay(container) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector('.loading__spinner');
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

function getClientCoords(event) {
  if (typeof event.clientX === 'number' && !Number.isNaN(event.clientX)) {
    return { x: event.clientX, y: event.clientY };
  }
  const t = event.touches?.[0] || event.changedTouches?.[0];
  if (t) return { x: t.clientX, y: t.clientY };
  return { x: 0, y: 0 };
}

function moveWithHover(image, event, zoomRatio, overlayEl) {
  const ratio = image.height / image.width;
  const rect = overlayEl.getBoundingClientRect();
  const { x: clientX, y: clientY } = getClientCoords(event);
  const xPosition = clientX - rect.left;
  const yPosition = clientY - rect.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlayEl.style.backgroundImage = `url('${image.src}')`;
  overlayEl.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlayEl.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function attachPanHandlers(overlayEl, image, zoomRatio) {
  const handler = (event) => {
    moveWithHover(image, event, zoomRatio, overlayEl);
  };

  if (window.PointerEvent) {
    overlayEl.addEventListener('pointermove', handler, { passive: false });
  } else {
    overlayEl.addEventListener('mousemove', handler);
  }
  /* Touch pan + block vertical scroll stealing the gesture */
  overlayEl.addEventListener(
    'touchmove',
    (event) => {
      event.preventDefault();
      handler(event);
    },
    { passive: false }
  );

  overlayEl.addEventListener('mouseleave', () => overlayEl.remove());
  overlayEl.addEventListener('click', (e) => {
    e.stopPropagation();
    overlayEl.remove();
  });
}

function createOverlay(image, zoomRatio, initialEvent) {
  if (image.parentElement.querySelector('.image-magnify-full-size') || image.dataset.magnifyPending === '1') {
    return;
  }
  image.dataset.magnifyPending = '1';

  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlayEl = document.createElement('div');
  prepareOverlay(overlayEl);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  let ready = false;
  const onOverlayReady = () => {
    if (ready) return;
    ready = true;
    image.dataset.magnifyPending = '0';
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlayEl, image);
    image.style.opacity = '100%';
    overlayEl.style.backgroundImage = `url('${image.src}')`;
    attachPanHandlers(overlayEl, image, zoomRatio);
    if (initialEvent) moveWithHover(image, initialEvent, zoomRatio, overlayEl);
  };

  overlayImage.onload = onOverlayReady;
  overlayImage.onerror = () => {
    image.dataset.magnifyPending = '0';
    toggleLoadingSpinner(image);
    image.style.opacity = '100%';
  };
  if (overlayImage.complete) onOverlayReady();
}

function magnify(image, zoomRatio, initialEvent) {
  const existing = image.parentElement.querySelector('.image-magnify-full-size');
  if (existing) {
    if (initialEvent) moveWithHover(image, initialEvent, zoomRatio, existing);
    return existing;
  }
  createOverlay(image, zoomRatio, initialEvent);
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.addEventListener('mouseenter', (event) => {
      magnify(image, zoomRatio, event);
    });

    image.addEventListener('click', (event) => {
      magnify(image, zoomRatio, event);
    });
  });
}

enableZoomOnHover(2);
